import React from "react";
import MenuItem from "@mui/material/MenuItem";
import MuiPagination from "@mui/material/Pagination";
import MuiTablePagination from "@mui/material/TablePagination";
import { compareValues, getClassName } from "@sscs/utils";
import { CheckIcon } from "../../icons";
import styles from "./tablePagination.module.scss";
const Actions = ({ count, page, rowsPerPage, onPageChange, className, }) => (React.createElement(MuiPagination, { className: className, count: Math.ceil(count / rowsPerPage), page: page + 1, boundaryCount: 1, siblingCount: 1, onChange: (_event, nextPage) => onPageChange(null, nextPage - 1) }));
const SizeOption = React.forwardRef(({ children, className, selected, ...props }, ref) => (React.createElement(MenuItem, { ...props, ref: ref, selected: selected, className: getClassName(styles.option, className) },
    React.createElement("span", null, children),
    selected ? React.createElement(CheckIcon, null) : null)));
SizeOption.displayName = "SizeOption";
/**
 * Dense Spectra pager: page pills plus a "{N} / page" size trigger whose menu opens upward.
 * Built on MUI `TablePagination`, driven by the {@link DataTablePagination} contract.
 */
const TablePagination = ({ id, itemCount, pagination: { currentPage, itemsPerPage }, onChange, initialItemCount, className, }) => {
    if (itemCount === 0)
        return null;
    const pageCount = Math.ceil(itemCount / itemsPerPage);
    const defaultItemsPerPage = initialItemCount !== null && initialItemCount !== void 0 ? initialItemCount : 10;
    if (pageCount === 1 &&
        currentPage === 1 &&
        itemsPerPage <= 10 &&
        defaultItemsPerPage === 10)
        return null;
    const options = Array.from(new Set([defaultItemsPerPage, 10, 20, 50, 100]))
        .sort((first, second) => compareValues(first, second, false))
        .map((value) => ({ label: `${value} / page`, value }));
    return (React.createElement(MuiTablePagination, { id: id, component: "div", className: getClassName(styles.root, className), count: itemCount, page: currentPage - 1, rowsPerPage: itemsPerPage, rowsPerPageOptions: options, labelRowsPerPage: null, labelDisplayedRows: () => null, onPageChange: (_event, nextPage) => onChange({ currentPage: nextPage + 1, itemsPerPage }), onRowsPerPageChange: (event) => onChange({
            currentPage: 1,
            itemsPerPage: parseInt(event.target.value, 10),
        }), ActionsComponent: Actions, slots: { menuItem: SizeOption }, slotProps: {
            toolbar: { disableGutters: true },
            select: {
                MenuProps: {
                    anchorOrigin: { vertical: "top", horizontal: "right" },
                    transformOrigin: { vertical: "bottom", horizontal: "right" },
                },
            },
        } }));
};
export default TablePagination;
//# sourceMappingURL=Pagination.js.map